"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ProgressBar = _interopRequireDefault(require("../ProgressBar"));

var _cloud = _interopRequireDefault(require("../icons/cloud.svg"));

var _panel = _interopRequireDefault(require("../icons/panel.svg"));

require("./processLoader.sass");

var _ref2 = _react.default.createElement("div", {
  className: "processLoader-pane"
}, _react.default.createElement(_cloud.default, {
  className: "processLoader-icon"
}), _react.default.createElement("div", {
  className: "processLoader-animation"
}, _react.default.createElement("div", {
  className: "processLoader-animation-progress"
}), _react.default.createElement("i", {
  className: "processLoader-animation-line"
}), _react.default.createElement("i", {
  className: "processLoader-animation-line"
}), _react.default.createElement("i", {
  className: "processLoader-animation-line"
}), _react.default.createElement("i", {
  className: "processLoader-animation-line"
})), _react.default.createElement(_panel.default, {
  className: "processLoader-icon"
}));

var ProcessLoader = function ProcessLoader(_ref) {
  var message = _ref.message,
      details = _ref.details,
      percentage = _ref.percentage;
  return _react.default.createElement("div", {
    className: "processLoader"
  }, _ref2, _react.default.createElement("p", {
    className: "processLoader-message"
  }, message), !!(percentage || details) && _react.default.createElement("p", {
    className: "processLoader-details"
  }, !!percentage && _react.default.createElement(_ProgressBar.default, {
    value: percentage,
    medium: true
  }), details));
};

ProcessLoader.propTypes = process.env.NODE_ENV !== "production" ? {
  percentage: _propTypes.default.number,
  message: _propTypes.default.string,
  details: _propTypes.default.string
} : {};
var _default = ProcessLoader;
exports.default = _default;